module.exports = __webpack_public_path__ + "static/media/kpp.822a6347.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/kpp.svg
// module id = 1533
// module chunks = 0